import sourceStatus from "./source-status.generated.json";

export interface EventSource {
  id: string;
  kind: "event";
  name: string;
  region: "한국" | "일본";
  role: string;
  sourceUrl: string;
  checkedAt: string;
  freshness: "current" | "recheck";
  ruleTasks: string[];
}

export interface EcosystemSource {
  id: string;
  kind: "studio" | "photography" | "marketplace" | "schedule" | "community";
  name: string;
  region: "한국" | "일본";
  role: string;
  sourceUrl: string;
  checkedAt: string;
  freshness: "current" | "recheck";
}

const observed = (id: string) => sourceStatus.sources.find((source) => source.id === id);
const observedDate = (id: string) => observed(id)?.checkedAt.slice(0, 10) ?? "2026-08-23";
const observedFreshness = (id: string): EventSource["freshness"] => observed(id)?.status === "reachable" ? "current" : "recheck";

export const eventSources: EventSource[] = [
  {
    id: "acosta",
    kind: "event",
    name: "acosta! Korea",
    region: "한국",
    role: "야외·전문 촬영형 코스프레 행사",
    sourceUrl: "https://acosta-korea.co.kr/",
    checkedAt: observedDate("acosta"),
    freshness: observedFreshness("acosta"),
    ruleTasks: ["최신 개최일 확인", "탈의·메이크업 동선 확인", "촬영 구역과 장비 규칙 확인"],
  },
  {
    id: "illustar",
    kind: "event",
    name: "일러스타 페스",
    region: "한국",
    role: "동인·크리에이터 마켓·코스프레 무대",
    sourceUrl: "https://illustar.net/",
    checkedAt: observedDate("illustar"),
    freshness: observedFreshness("illustar"),
    ruleTasks: ["코스프레 입장권 확인", "탈의실·보관소 확인", "무대·촬영 동의 범위 확인"],
  },
  {
    id: "comicworld",
    kind: "event",
    name: "코믹월드",
    region: "한국",
    role: "만화·애니 동인 행사와 코스튬 플레이",
    sourceUrl: "https://comicw.co.kr/",
    checkedAt: observedDate("comicworld"),
    freshness: observedFreshness("comicworld"),
    ruleTasks: ["현재 운영·개최 여부 재확인", "티켓·탈의실 공지 확인", "촬영·휴식 구역 공지 확인"],
  },
  {
    id: "acosta-jp",
    kind: "event",
    name: "acosta! Japan",
    region: "일본",
    role: "일본 지역별 코스프레 행사",
    sourceUrl: "https://acosta.jp/",
    checkedAt: observedDate("acosta-jp"),
    freshness: observedFreshness("acosta-jp"),
    ruleTasks: ["최신 개최지·날짜 확인", "티켓·환복·짐 보관 규칙 확인", "촬영 구역과 장비 규칙 확인"],
  },
];

const ecosystem = (id: string, kind: EcosystemSource["kind"], name: string, role: string, sourceUrl: string): EcosystemSource => ({
  id,
  kind,
  name,
  region: "일본",
  role,
  sourceUrl,
  checkedAt: observedDate(id),
  freshness: observedFreshness(id),
});

export const ecosystemSources: EcosystemSource[] = [
  ecosystem("hacosta-studio", "studio", "Hacosta Studio", "스튜디오·로케이션 이용규칙 참고", "https://www.hacosta.co.jp/service/"),
  ecosystem("sirius", "photography", "Sirius Photography", "전문 촬영 가격·취소·납기 참고", "https://sirius-cos.com/price/"),
  ecosystem("cosma", "marketplace", "COSMA", "작품·캐릭터·사이즈 기반 중고거래 참고", "https://cosma.tokyo/about"),
  ecosystem("awase", "schedule", "awase.STUDIO", "함께 촬영 일정 자동 생성 참고", "https://awase.studio/"),
  ecosystem("claps", "community", "Claps!", "기간형 코스프레 도전·응원 구조 참고", "https://www.claps.pro/faq.aspx"),
  ecosystem("cosp-market", "marketplace", "Cure / Cosp Market archive", "코스프레 중고거래 상태·배송 안내 참고", "https://www.cosp.jp/market_faq.aspx"),
];
